import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
export function MiniProductReveal() {
  return <Section background="gradient-purple" containerSize="md" className="text-center" data-id="element-205">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6
    }} data-id="element-206">
        <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-6" data-id="element-207">
          Por eso existe{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600" data-id="element-208">
            ENERGÍA REAL
          </span>
        </h2>

        <p className="text-xl md:text-2xl text-slate-700 leading-relaxed max-w-3xl mx-auto" data-id="element-209">
          ENERGÍA REAL no busca que hagas más cosas. Busca que dejes de perder
          energía donde no vuelve.
        </p>

        <div className="mt-8 p-6 bg-white/40 rounded-2xl border border-fuchsia-100" data-id="element-210">
          <p className="text-lg md:text-xl text-slate-800 font-medium" data-id="element-211">
            Es un método amable, pensado para mujeres reales, con trabajo,
            estudio y casa, que están cansadas de exigirse para poder con todo.
          </p>
        </div>
      </motion.div>
    </Section>;
}